import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'meeting-analysis-api.vendasta-local.com',
  'test': '',
  'demo': 'meeting-analysis-demo.apigateway.co',
  'prod': 'meeting-analysis-prod.apigateway.co',
  'production': 'meeting-analysis-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ConversationSortField = /*#__PURE__*/function (ConversationSortField) {
  ConversationSortField[ConversationSortField["CONVERSATION_SORT_FIELD_UNSPECIFIED"] = 0] = "CONVERSATION_SORT_FIELD_UNSPECIFIED";
  ConversationSortField[ConversationSortField["CONVERSATION_SORT_FIELD_CREATED"] = 1] = "CONVERSATION_SORT_FIELD_CREATED";
  ConversationSortField[ConversationSortField["CONVERSATION_SORT_FIELD_UPDATED"] = 2] = "CONVERSATION_SORT_FIELD_UPDATED";
  ConversationSortField[ConversationSortField["CONVERSATION_SORT_FIELD_TITLE"] = 3] = "CONVERSATION_SORT_FIELD_TITLE";
  ConversationSortField[ConversationSortField["CONVERSATION_SORT_FIELD_SENTIMENT"] = 4] = "CONVERSATION_SORT_FIELD_SENTIMENT";
  ConversationSortField[ConversationSortField["CONVERSATION_SORT_FIELD_SALES_SCORE"] = 5] = "CONVERSATION_SORT_FIELD_SALES_SCORE";
  return ConversationSortField;
}(ConversationSortField || {});
var ConversationSource = /*#__PURE__*/function (ConversationSource) {
  ConversationSource[ConversationSource["CONVERSATION_SOURCE_UNSPECIFIED"] = 0] = "CONVERSATION_SOURCE_UNSPECIFIED";
  ConversationSource[ConversationSource["CONVERSATION_SOURCE_GOOGLE_MEET"] = 1] = "CONVERSATION_SOURCE_GOOGLE_MEET";
  ConversationSource[ConversationSource["CONVERSATION_SOURCE_GONG"] = 2] = "CONVERSATION_SOURCE_GONG";
  ConversationSource[ConversationSource["CONVERSATION_SOURCE_TEAMS"] = 3] = "CONVERSATION_SOURCE_TEAMS";
  ConversationSource[ConversationSource["CONVERSATION_SOURCE_ZOOM"] = 4] = "CONVERSATION_SOURCE_ZOOM";
  ConversationSource[ConversationSource["CONVERSATION_SOURCE_KIXIE"] = 5] = "CONVERSATION_SOURCE_KIXIE";
  return ConversationSource;
}(ConversationSource || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Context = /*#__PURE__*/function (Context) {
  Context[Context["SALES_COACH_CONFIG_CONTEXT_UNSET"] = 0] = "SALES_COACH_CONFIG_CONTEXT_UNSET";
  Context[Context["SALES_COACH_CONFIG_CONTEXT_PARTNER"] = 1] = "SALES_COACH_CONFIG_CONTEXT_PARTNER";
  Context[Context["SALES_COACH_CONFIG_CONTEXT_SMB"] = 2] = "SALES_COACH_CONFIG_CONTEXT_SMB";
  return Context;
}(Context || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EvaluationFeedback = /*#__PURE__*/function (EvaluationFeedback) {
  EvaluationFeedback[EvaluationFeedback["EVALUATION_FEEDBACK_UNDEFINED"] = 0] = "EVALUATION_FEEDBACK_UNDEFINED";
  EvaluationFeedback[EvaluationFeedback["EVALUATION_FEEDBACK_POSITIVE"] = 1] = "EVALUATION_FEEDBACK_POSITIVE";
  EvaluationFeedback[EvaluationFeedback["EVALUATION_FEEDBACK_NEGATIVE"] = 2] = "EVALUATION_FEEDBACK_NEGATIVE";
  return EvaluationFeedback;
}(EvaluationFeedback || {});
var EvaluationReason = /*#__PURE__*/function (EvaluationReason) {
  EvaluationReason[EvaluationReason["EVALUATION_REASON_UNDEFINED"] = 0] = "EVALUATION_REASON_UNDEFINED";
  EvaluationReason[EvaluationReason["EVALUATION_REASON_INACCURATE_SUMMARY"] = 1] = "EVALUATION_REASON_INACCURATE_SUMMARY";
  EvaluationReason[EvaluationReason["EVALUATION_REASON_INACCURATE_TAKEAWAYS"] = 2] = "EVALUATION_REASON_INACCURATE_TAKEAWAYS";
  EvaluationReason[EvaluationReason["EVALUATION_REASON_INACCURATE_ACTION_ITEMS"] = 3] = "EVALUATION_REASON_INACCURATE_ACTION_ITEMS";
  EvaluationReason[EvaluationReason["EVALUATION_REASON_LACK_OF_DETAILS"] = 4] = "EVALUATION_REASON_LACK_OF_DETAILS";
  EvaluationReason[EvaluationReason["EVALUATION_REASON_WRONG_SPEAKERS"] = 5] = "EVALUATION_REASON_WRONG_SPEAKERS";
  EvaluationReason[EvaluationReason["EVALUATION_REASON_OTHER"] = 6] = "EVALUATION_REASON_OTHER";
  return EvaluationReason;
}(EvaluationReason || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_UNSET"] = 0] = "SORT_DIRECTION_UNSET";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
class MCPOptions {
  static fromProto(proto) {
    let m = new MCPOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serverId !== 'undefined') {
      toReturn['serverId'] = this.serverId;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Conversation {
  static fromProto(proto) {
    let m = new Conversation();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$3(ConversationSource, proto.source);
    }
    if (proto.meetingDate) {
      m.meetingDate = new Date(proto.meetingDate);
    }
    if (proto.externalAttendees) {
      m.externalAttendees = proto.externalAttendees.map(ExternalAttendee.fromProto);
    }
    if (proto.sentiment) {
      m.sentiment = parseInt(proto.sentiment, 10);
    }
    if (proto.salesScore) {
      m.salesScore = parseInt(proto.salesScore, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.transcriptEntries) {
      m.transcriptEntries = proto.transcriptEntries.map(TranscriptEntry.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.rawTranscript !== 'undefined') {
      toReturn['rawTranscript'] = this.rawTranscript;
    }
    if (typeof this.recordingUrl !== 'undefined') {
      toReturn['recordingUrl'] = this.recordingUrl;
    }
    if (typeof this.meetingDate !== 'undefined' && this.meetingDate !== null) {
      toReturn['meetingDate'] = 'toApiJson' in this.meetingDate ? this.meetingDate.toApiJson() : this.meetingDate;
    }
    if (typeof this.internalAttendees !== 'undefined') {
      toReturn['internalAttendees'] = this.internalAttendees;
    }
    if (typeof this.externalAttendees !== 'undefined' && this.externalAttendees !== null) {
      toReturn['externalAttendees'] = 'toApiJson' in this.externalAttendees ? this.externalAttendees.toApiJson() : this.externalAttendees;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.summary !== 'undefined') {
      toReturn['summary'] = this.summary;
    }
    if (typeof this.keywords !== 'undefined') {
      toReturn['keywords'] = this.keywords;
    }
    if (typeof this.keyTakeaways !== 'undefined') {
      toReturn['keyTakeaways'] = this.keyTakeaways;
    }
    if (typeof this.actionItems !== 'undefined') {
      toReturn['actionItems'] = this.actionItems;
    }
    if (typeof this.sentiment !== 'undefined') {
      toReturn['sentiment'] = this.sentiment;
    }
    if (typeof this.sentimentExplanation !== 'undefined') {
      toReturn['sentimentExplanation'] = this.sentimentExplanation;
    }
    if (typeof this.salesScore !== 'undefined') {
      toReturn['salesScore'] = this.salesScore;
    }
    if (typeof this.salesScoreExplanation !== 'undefined') {
      toReturn['salesScoreExplanation'] = this.salesScoreExplanation;
    }
    if (typeof this.analysingModelUsed !== 'undefined') {
      toReturn['analysingModelUsed'] = this.analysingModelUsed;
    }
    if (typeof this.promptUsed !== 'undefined') {
      toReturn['promptUsed'] = this.promptUsed;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.transcriptEntries !== 'undefined' && this.transcriptEntries !== null) {
      toReturn['transcriptEntries'] = 'toApiJson' in this.transcriptEntries ? this.transcriptEntries.toApiJson() : this.transcriptEntries;
    }
    return toReturn;
  }
}
class ExternalAttendee {
  static fromProto(proto) {
    let m = new ExternalAttendee();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    return toReturn;
  }
}
class TranscriptEntry {
  static fromProto(proto) {
    let m = new TranscriptEntry();
    m = Object.assign(m, proto);
    if (proto.words) {
      m.words = proto.words.map(Words.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.words !== 'undefined' && this.words !== null) {
      toReturn['words'] = 'toApiJson' in this.words ? this.words.toApiJson() : this.words;
    }
    return toReturn;
  }
}
class Words {
  static fromProto(proto) {
    let m = new Words();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.startTime !== 'undefined') {
      toReturn['startTime'] = this.startTime;
    }
    if (typeof this.endTime !== 'undefined') {
      toReturn['endTime'] = this.endTime;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SalesCoachConfig {
  static fromProto(proto) {
    let m = new SalesCoachConfig();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue$2(Context, proto.context);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.joinMeetings !== 'undefined') {
      toReturn['joinMeetings'] = this.joinMeetings;
    }
    if (typeof this.notetakerName !== 'undefined') {
      toReturn['notetakerName'] = this.notetakerName;
    }
    if (typeof this.showRecordingConsentMessages !== 'undefined') {
      toReturn['showRecordingConsentMessages'] = this.showRecordingConsentMessages;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class SalesCoachUserConfig {
  static fromProto(proto) {
    let m = new SalesCoachUserConfig();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.joinMeetings !== 'undefined') {
      toReturn['joinMeetings'] = this.joinMeetings;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateConversationRequest {
  static fromProto(proto) {
    let m = new CreateConversationRequest();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    return toReturn;
  }
}
class CreateConversationResponse {
  static fromProto(proto) {
    let m = new CreateConversationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateEvaluationRequest {
  static fromProto(proto) {
    let m = new CreateEvaluationRequest();
    m = Object.assign(m, proto);
    if (proto.feedback) {
      m.feedback = enumStringToValue(EvaluationFeedback, proto.feedback);
    }
    if (proto.reasons) {
      m.reasons = proto.reasons.map(v => enumStringToValue(EvaluationReason, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    if (typeof this.feedback !== 'undefined') {
      toReturn['feedback'] = this.feedback;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    if (typeof this.reasons !== 'undefined') {
      toReturn['reasons'] = this.reasons;
    }
    return toReturn;
  }
}
class CreateSalesCoachConfigRequest {
  static fromProto(proto) {
    let m = new CreateSalesCoachConfigRequest();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue(Context, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.joinMeetings !== 'undefined') {
      toReturn['joinMeetings'] = this.joinMeetings;
    }
    if (typeof this.notetakerName !== 'undefined') {
      toReturn['notetakerName'] = this.notetakerName;
    }
    if (typeof this.showRecordingConsentMessages !== 'undefined') {
      toReturn['showRecordingConsentMessages'] = this.showRecordingConsentMessages;
    }
    return toReturn;
  }
}
class CreateSalesCoachUserConfigRequest {
  static fromProto(proto) {
    let m = new CreateSalesCoachUserConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.joinMeetings !== 'undefined') {
      toReturn['joinMeetings'] = this.joinMeetings;
    }
    return toReturn;
  }
}
class CreateSalesConfigResponse {
  static fromProto(proto) {
    let m = new CreateSalesConfigResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeleteSalesCoachConfigRequest {
  static fromProto(proto) {
    let m = new DeleteSalesCoachConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class DeleteSalesCoachUserConfigRequest {
  static fromProto(proto) {
    let m = new DeleteSalesCoachUserConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class ListConversationsRequestFilters {
  static fromProto(proto) {
    let m = new ListConversationsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue(ConversationSource, proto.source);
    }
    if (proto.sentiment) {
      m.sentiment = parseInt(proto.sentiment, 10);
    }
    if (proto.salesScore) {
      m.salesScore = parseInt(proto.salesScore, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.keywords !== 'undefined') {
      toReturn['keywords'] = this.keywords;
    }
    if (typeof this.sentiment !== 'undefined') {
      toReturn['sentiment'] = this.sentiment;
    }
    if (typeof this.salesScore !== 'undefined') {
      toReturn['salesScore'] = this.salesScore;
    }
    return toReturn;
  }
}
class GetConversationRequest {
  static fromProto(proto) {
    let m = new GetConversationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetConversationResponse {
  static fromProto(proto) {
    let m = new GetConversationResponse();
    m = Object.assign(m, proto);
    if (proto.conversation) {
      m.conversation = Conversation.fromProto(proto.conversation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversation !== 'undefined' && this.conversation !== null) {
      toReturn['conversation'] = 'toApiJson' in this.conversation ? this.conversation.toApiJson() : this.conversation;
    }
    return toReturn;
  }
}
class GetRecordingURLRequest {
  static fromProto(proto) {
    let m = new GetRecordingURLRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversationId !== 'undefined') {
      toReturn['conversationId'] = this.conversationId;
    }
    return toReturn;
  }
}
class GetRecordingURLResponse {
  static fromProto(proto) {
    let m = new GetRecordingURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recordingUrl !== 'undefined') {
      toReturn['recordingUrl'] = this.recordingUrl;
    }
    return toReturn;
  }
}
class GetSalesCoachConfigRequest {
  static fromProto(proto) {
    let m = new GetSalesCoachConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetSalesCoachConfigResponse {
  static fromProto(proto) {
    let m = new GetSalesCoachConfigResponse();
    m = Object.assign(m, proto);
    if (proto.salesCoachConfig) {
      m.salesCoachConfig = SalesCoachConfig.fromProto(proto.salesCoachConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesCoachConfig !== 'undefined' && this.salesCoachConfig !== null) {
      toReturn['salesCoachConfig'] = 'toApiJson' in this.salesCoachConfig ? this.salesCoachConfig.toApiJson() : this.salesCoachConfig;
    }
    return toReturn;
  }
}
class GetSalesCoachUserConfigRequest {
  static fromProto(proto) {
    let m = new GetSalesCoachUserConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetSalesCoachUserConfigResponse {
  static fromProto(proto) {
    let m = new GetSalesCoachUserConfigResponse();
    m = Object.assign(m, proto);
    if (proto.salesCoachUserConfig) {
      m.salesCoachUserConfig = SalesCoachUserConfig.fromProto(proto.salesCoachUserConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesCoachUserConfig !== 'undefined' && this.salesCoachUserConfig !== null) {
      toReturn['salesCoachUserConfig'] = 'toApiJson' in this.salesCoachUserConfig ? this.salesCoachUserConfig.toApiJson() : this.salesCoachUserConfig;
    }
    return toReturn;
  }
}
class ListConversationsRequest {
  static fromProto(proto) {
    let m = new ListConversationsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListConversationsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.sort) {
      m.sort = ListConversationsRequestSort.fromProto(proto.sort);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.sort !== 'undefined' && this.sort !== null) {
      toReturn['sort'] = 'toApiJson' in this.sort ? this.sort.toApiJson() : this.sort;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListConversationsResponse {
  static fromProto(proto) {
    let m = new ListConversationsResponse();
    m = Object.assign(m, proto);
    if (proto.conversations) {
      m.conversations = proto.conversations.map(Conversation.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversations !== 'undefined' && this.conversations !== null) {
      toReturn['conversations'] = 'toApiJson' in this.conversations ? this.conversations.toApiJson() : this.conversations;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ScheduleBotRequest {
  static fromProto(proto) {
    let m = new ScheduleBotRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.meetingUrl !== 'undefined') {
      toReturn['meetingUrl'] = this.meetingUrl;
    }
    return toReturn;
  }
}
class ListConversationsRequestSort {
  static fromProto(proto) {
    let m = new ListConversationsRequestSort();
    m = Object.assign(m, proto);
    if (proto.field) {
      m.field = enumStringToValue(ConversationSortField, proto.field);
    }
    if (proto.direction) {
      m.direction = enumStringToValue(SortDirection, proto.direction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    return toReturn;
  }
}
class UpdateSalesCoachConfigRequest {
  static fromProto(proto) {
    let m = new UpdateSalesCoachConfigRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.joinMeetings !== 'undefined') {
      toReturn['joinMeetings'] = this.joinMeetings;
    }
    if (typeof this.notetakerName !== 'undefined') {
      toReturn['notetakerName'] = this.notetakerName;
    }
    if (typeof this.showRecordingConsentMessages !== 'undefined') {
      toReturn['showRecordingConsentMessages'] = this.showRecordingConsentMessages;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateSalesCoachUserConfigRequest {
  static fromProto(proto) {
    let m = new UpdateSalesCoachUserConfigRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.joinMeetings !== 'undefined') {
      toReturn['joinMeetings'] = this.joinMeetings;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MeetingAnalysisApiService = /*#__PURE__*/(() => {
  class MeetingAnalysisApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createConversation(r) {
      const request = r.toApiJson ? r : new CreateConversationRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.MeetingAnalysis/CreateConversation", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateConversationResponse.fromProto(resp)));
    }
    listConversations(r) {
      const request = r.toApiJson ? r : new ListConversationsRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.MeetingAnalysis/ListConversations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListConversationsResponse.fromProto(resp)));
    }
    getConversation(r) {
      const request = r.toApiJson ? r : new GetConversationRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.MeetingAnalysis/GetConversation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConversationResponse.fromProto(resp)));
    }
    createEvaluation(r) {
      const request = r.toApiJson ? r : new CreateEvaluationRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.MeetingAnalysis/CreateEvaluation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getRecordingUrl(r) {
      const request = r.toApiJson ? r : new GetRecordingURLRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.MeetingAnalysis/GetRecordingURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRecordingURLResponse.fromProto(resp)));
    }
  }
  MeetingAnalysisApiService.ɵfac = function MeetingAnalysisApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MeetingAnalysisApiService)();
  };
  MeetingAnalysisApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MeetingAnalysisApiService,
    factory: MeetingAnalysisApiService.ɵfac,
    providedIn: 'root'
  });
  return MeetingAnalysisApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MeetingBotApiService = /*#__PURE__*/(() => {
  class MeetingBotApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    scheduleBot(r) {
      const request = r.toApiJson ? r : new ScheduleBotRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.MeetingBotService/ScheduleBot", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  MeetingBotApiService.ɵfac = function MeetingBotApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MeetingBotApiService)();
  };
  MeetingBotApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MeetingBotApiService,
    factory: MeetingBotApiService.ɵfac,
    providedIn: 'root'
  });
  return MeetingBotApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesCoachConfigApiService = /*#__PURE__*/(() => {
  class SalesCoachConfigApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSalesCoachConfigRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.SalesCoachConfigService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesCoachConfigResponse.fromProto(resp)));
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateSalesCoachConfigRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.SalesCoachConfigService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSalesConfigResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateSalesCoachConfigRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.SalesCoachConfigService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteSalesCoachConfigRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.SalesCoachConfigService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getUserConfig(r) {
      const request = r.toApiJson ? r : new GetSalesCoachUserConfigRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.SalesCoachConfigService/GetUserConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesCoachUserConfigResponse.fromProto(resp)));
    }
    createUserConfig(r) {
      const request = r.toApiJson ? r : new CreateSalesCoachUserConfigRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.SalesCoachConfigService/CreateUserConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateUserConfig(r) {
      const request = r.toApiJson ? r : new UpdateSalesCoachUserConfigRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.SalesCoachConfigService/UpdateUserConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteUserConfig(r) {
      const request = r.toApiJson ? r : new DeleteSalesCoachUserConfigRequest(r);
      return this.http.post(this._host + "/meeting_analysis.v1.SalesCoachConfigService/DeleteUserConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SalesCoachConfigApiService.ɵfac = function SalesCoachConfigApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesCoachConfigApiService)();
  };
  SalesCoachConfigApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesCoachConfigApiService,
    factory: SalesCoachConfigApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesCoachConfigApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let TranscriptService = /*#__PURE__*/(() => {
  class TranscriptService {
    constructor(hostService) {
      this.hostService = hostService;
    }
    getTranscriptUrl(conversationId) {
      return `${this.hostService.hostWithScheme}/rawTranscript/${conversationId}/download`;
    }
  }
  TranscriptService.ɵfac = function TranscriptService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TranscriptService)(i0.ɵɵinject(HostService));
  };
  TranscriptService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TranscriptService,
    factory: TranscriptService.ɵfac,
    providedIn: 'root'
  });
  return TranscriptService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, Context, Conversation, ConversationSortField, ConversationSource, CreateConversationRequest, CreateConversationResponse, CreateEvaluationRequest, CreateSalesCoachConfigRequest, CreateSalesCoachUserConfigRequest, CreateSalesConfigResponse, DeleteSalesCoachConfigRequest, DeleteSalesCoachUserConfigRequest, EvaluationFeedback, EvaluationReason, ExternalAttendee, FieldMask, GetConversationRequest, GetConversationResponse, GetRecordingURLRequest, GetRecordingURLResponse, GetSalesCoachConfigRequest, GetSalesCoachConfigResponse, GetSalesCoachUserConfigRequest, GetSalesCoachUserConfigResponse, HostService, ListConversationsRequest, ListConversationsRequestFilters, ListConversationsRequestSort, ListConversationsResponse, MCPOptions, MeetingAnalysisApiService, MeetingBotApiService, PagedRequestOptions, PagedResponseMetadata, SalesCoachConfig, SalesCoachConfigApiService, SalesCoachUserConfig, ScheduleBotRequest, SortDirection, TranscriptEntry, TranscriptService, UpdateSalesCoachConfigRequest, UpdateSalesCoachUserConfigRequest, Words };
